module.exports = require('./src/create')(require('./src/logger/browser')())
